import { updateObject } from '../../utils';
import actionTypes from '../constants/actionTypes';

const initialState = {
  loading: false,
  hub: null,
  error: null,
};

const hubReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.START_GET_HUB:
      return updateObject(state, { loading: true });
    case actionTypes.SUCCESS_GET_HUB:
      return updateObject(state, {
        loading: false,
        hub: action.hub,
        error: null,
      });
    case actionTypes.ERROR_GET_HUB:
      return updateObject(state, { loading: false, error: action.error });
    default:
      return state;
  }
};

export default hubReducer;
